// Textos propis de la pàgina "newsletter" per idioma (Newsletter.jsx).

const textos = {
    es: {
        heroImageAlt: "¡Suscríbete a la newsletter del Hotel Camprodon!",
        heroSmallTitle: "Te informamos de las últimas novedades y ofertas",
        heroTitle: "¡Suscríbete a la newsletter del Hotel Camprodon!",
        languageValue: "es",
        checkboxHref: "/politica-de-privacidad",
    },
    ca: {
        heroImageAlt: "Subscriu-te al newsletter de l'Hotel Camprodon!",
        heroSmallTitle: "T'informem de les darreres novetats i ofertes",
        heroTitle: "Subscriu-te al newsletter de l'Hotel Camprodon!",
        languageValue: "ca",
        checkboxHref: "/ca/politica-de-privacitat",
    },
    en: {
        heroImageAlt: "Subscribe to the Hotel Camprodon newsletter!",
        heroSmallTitle: "We keep you informed of the latest news and deals",
        heroTitle: "Subscribe to the Hotel Camprodon newsletter!",
        languageValue: "en",
        checkboxHref: "/en/privacy-policy",
    },
    fr: {
        heroImageAlt: "Abonnez-vous à la newsletter de l'Hotel Camprodon !",
        heroSmallTitle: "Nous vous informons des dernières nouveautés et offres",
        heroTitle: "Abonnez-vous à la newsletter de l'Hotel Camprodon !",
        languageValue: "fr",
        checkboxHref: "/fr/politique-de-confidentialite",
    },
    de: {
        heroImageAlt: "Abonnieren Sie den Newsletter des Hotel Camprodon!",
        heroSmallTitle: "Wir informieren Sie über die neuesten Neuigkeiten und Angebote",
        heroTitle: "Abonnieren Sie den Newsletter des Hotel Camprodon!",
        languageValue: "de",
        checkboxHref: "/de/privacy-policy",
    },
    it: {
        heroImageAlt: "Iscriviti alla newsletter dell'Hotel Camprodon!",
        heroSmallTitle: "Ti informiamo sulle ultime novità e offerte",
        heroTitle: "Iscriviti alla newsletter dell'Hotel Camprodon!",
        languageValue: "it",
        checkboxHref: "/it/informativa-sulla-privacy",
    },
    pt: {
        heroImageAlt: "Subscreva a newsletter do Hotel Camprodon!",
        heroSmallTitle: "Informamos sobre as últimas novidades e ofertas",
        heroTitle: "Subscreva a newsletter do Hotel Camprodon!",
        languageValue: "pt",
        checkboxHref: "/pt/politica-de-privacidade",
    },
    nl: {
        heroImageAlt: "Schrijf je in voor de nieuwsbrief van Hotel Camprodon!",
        heroSmallTitle: "We houden je op de hoogte van het laatste nieuws en aanbiedingen",
        heroTitle: "Schrijf je in voor de nieuwsbrief van Hotel Camprodon!",
        languageValue: "nl",
        checkboxHref: "/nl/privacy-beleid",
    },
    cs: {
        heroImageAlt: "Přihlaste se k odběru newsletteru hotelu Hotel Camprodon!",
        heroSmallTitle: "Informujeme vás o nejnovějších novinkách a nabídkách",
        heroTitle: "Přihlaste se k odběru newsletteru hotelu Hotel Camprodon!",
        languageValue: "cs",
        checkboxHref: "/cs/zasady-ochrany-soukromí",
    },
    ru: {
        heroImageAlt: "Подпишитесь на рассылку Hotel Camprodon!",
        heroSmallTitle: "Сообщаем о последних новостях и предложениях",
        heroTitle: "Подпишитесь на рассылку Hotel Camprodon!",
        languageValue: "ru",
        checkboxHref: "/ru/politika-otmeny",
    },
    sv: {
        heroImageAlt: "Prenumerera på Hotel Camprodons nyhetsbrev!",
        heroSmallTitle: "Vi berättar om de senaste nyheterna och erbjudandena",
        heroTitle: "Prenumerera på Hotel Camprodons nyhetsbrev!",
        languageValue: "sv",
        checkboxHref: "/sv/privacy-policy",
    },
};

export default textos;
